import {useEffect, useRef} from 'react'

import {isLoggedIn} from '@github-ui/client-env'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import {PreheatIssuesIndexManager} from './preheat-issues-index-manager'

export function usePreheatIssuesIndex(owner: string | undefined, repo: string | undefined, source: string | undefined) {
  const preHeatingEnabled = !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn()
  const managerRef = useRef<PreheatIssuesIndexManager | null>(null)

  useEffect(() => {
    if (!preHeatingEnabled) return
    if (!owner || !repo || !source) return

    if (!managerRef.current) {
      managerRef.current = new PreheatIssuesIndexManager()
    }

    const manager = managerRef.current

    async function run() {
      try {
        if (!owner || !repo || !source) return
        await manager.preheat(owner, repo, source)
      } catch {
        // Preheating is best-effort; swallow errors silently.
      }
    }

    void run()
  }, [preHeatingEnabled, owner, repo, source])
}
